import { css, useTheme } from '@emotion/react';
import { Link } from 'react-router-dom';

import { fontFamilies, fontSizes, radii, shadows, spacing } from '@/theme/tokens';

export function NotFound() {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        text-align: center;
        gap: ${spacing.md};
        padding: ${spacing.xl};
        background: ${theme.colors.background};
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: ${spacing.sm};
          margin-bottom: ${spacing.md};
        `}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="2" y="6" width="4" height="12" rx="1" fill={theme.colors.primary} />
          <rect
            x="8"
            y="3"
            width="4"
            height="18"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.7"
          />
          <rect
            x="14"
            y="8"
            width="4"
            height="8"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.5"
          />
          <rect
            x="20"
            y="5"
            width="4"
            height="14"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.3"
          />
        </svg>
        <span
          css={css`
            font-family: ${fontFamilies.display};
            font-size: ${fontSizes.lg};
            font-weight: 700;
            color: ${theme.colors.text};
          `}
        >
          Sonematic
        </span>
      </div>
      <span
        css={css`
          font-family: ${fontFamilies.display};
          font-size: 6rem;
          font-weight: 800;
          color: ${theme.colors.primary};
          opacity: 0.15;
          line-height: 1;
        `}
      >
        404
      </span>
      <h1
        css={css`
          font-size: ${fontSizes.xxl};
          font-weight: 700;
          color: ${theme.colors.text};
          margin: 0;
        `}
      >
        Page Not Found
      </h1>
      <p
        css={css`
          color: ${theme.colors.textSecondary};
          margin: 0;
        `}
      >
        The page you are looking for does not exist.
      </p>
      <Link
        to="/"
        css={css`
          display: inline-flex;
          align-items: center;
          gap: ${spacing.xs};
          padding: 10px 24px;
          background: ${theme.colors.buttonBg};
          border: 1px solid ${theme.colors.buttonBorder};
          box-shadow: ${shadows.insetButton};
          color: ${theme.colors.primaryText};
          text-decoration: none;
          border-radius: ${radii.button};
          font-size: ${fontSizes.sm};
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.2px;
          margin-top: ${spacing.sm};
          transition: background 0.15s ease;
          &:hover {
            background: ${theme.colors.primaryHover};
          }
        `}
      >
        Go Home
      </Link>
    </div>
  );
}
